import { ComponentProps } from "react";

import { useBillingPipelineFeature } from "@/billing/hooks/useBillingPipelineFeature";

import { ProceduresSection } from "../ProceduresTab";

import EncounterProcedures from "./EncounterProcedures";

type EncounterObjectiveProceduresProps<T> = ComponentProps<typeof EncounterProcedures<T>> & {
  isEncounterActive: boolean;
};

/**
 * The Objective tab's Procedures section. With the billing pipeline on it is the Procedures tab's
 * own card and picker, staged onto the same encounter save; with it off it is the legacy CPT list
 * and drawer.
 *
 * Switched on the same flag as the Dx tab's Diagnoses section: the legacy Diagnoses section reads
 * the procedures the legacy section loads, so the two have to flip together.
 */
const EncounterObjectiveProcedures = <T,>({
  isEncounterActive,
  ...legacyProps
}: EncounterObjectiveProceduresProps<T>) => {
  const isBillingPipelineEnabled = useBillingPipelineFeature();

  if (isBillingPipelineEnabled)
    return (
      <ProceduresSection
        isAmendment={legacyProps.isAmendment}
        isEncounterActive={isEncounterActive}
      />
    );

  return <EncounterProcedures {...legacyProps} />;
};

export default EncounterObjectiveProcedures;
